import { Child, ChildChunks } from "./store.js";
import wrappedFetch from "../../wrappedFetch.js";

export const GetChild = async (id) => {
    let child = await wrappedFetch("child/GetChildDetails?childId=" + id + '&x=' + new Date().getTime()).then(result => result.json());
    Child.set(child);
    return child;
}
